import { render, staticRenderFns } from "./standardCommonThirdSubFolder.vue?vue&type=template&id=28b0bff0&scoped=true"
import script from "./standardCommonThirdSubFolder.vue?vue&type=script&lang=js"
export * from "./standardCommonThirdSubFolder.vue?vue&type=script&lang=js"
import style0 from "./standardCommonThirdSubFolder.vue?vue&type=style&index=0&id=28b0bff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0bff0",
  null
  
)

export default component.exports